import { render, staticRenderFns } from "./p13.vue?vue&type=template&id=0a5772cf&scoped=true&"
import script from "./p13.vue?vue&type=script&lang=js&"
export * from "./p13.vue?vue&type=script&lang=js&"
import style0 from "./p13.vue?vue&type=style&index=0&id=0a5772cf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5772cf",
  null
  
)

export default component.exports